import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import EventDetails from '../../components/admincomponents/EventDetails';

function ViewEvent({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <EventDetails />            
    </>
  );
}

export default ViewEvent;
